var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Test Email")]),_c('p',[_vm._v("Click the button below to send a test email.")]),_c('button',{on:{"click":_vm.sendTestEmail}},[_vm._v("Send Test Email")])])
}
var staticRenderFns = []

export { render, staticRenderFns }